/* eslint-disable import/prefer-default-export */
import { formValueSelector } from 'redux-form';
import { LAST_NAME } from './constants';
import getTravelerFormSectionName from './travelerFormName';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, LAST_NAME)) || null;
//# sourceMappingURL=lastName.js.map